import React from "react";
import PropTypes from "prop-types";

function Phone({ className, style, fill, defaultWidth, defaultHeight }) {
  return (
    <svg
      viewBox="0 0 15 25"
      width={style && style.width ? style.width : defaultWidth}
      height={style && style.width ? style.height : defaultHeight}
      style={style}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g transform="translate(-800 -377)" fill={fill} fill-rule="nonzero">
          <g id="Group" transform="translate(800 377)">
            <path
              d="M12.5 0h-10C1.122 0 0 1.094 0 2.438v19.5c0 1.344 1.122 2.437 2.5 2.437h10c1.379 0 2.5-1.093 2.5-2.438v-19.5C15 1.095 13.879 0 12.5 0zM14 21.938c0 .806-.673 1.462-1.5 1.462h-10c-.827 0-1.5-.656-1.5-1.462v-19.5C1 1.63 1.673.974 2.5.974h10c.827 0 1.5.656 1.5 1.462v19.5z"
              id="Shape"
            />
            <path
              d="M8.906 1.875H7.031a.469.469 0 000 .938h1.875a.469.469 0 000-.938zM7.969 21.563a.469.469 0 100 .937.469.469 0 000-.938zM14.5 3.75H.5c-.276 0-.5.21-.5.469s.224.468.5.468h14c.276 0 .5-.21.5-.468 0-.259-.224-.469-.5-.469zM14.5 19.688H.5c-.276 0-.5.21-.5.468 0 .259.224.469.5.469h14c.276 0 .5-.21.5-.469 0-.258-.224-.468-.5-.468z"
              id="Path"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

Phone.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  fill: PropTypes.string
};

Phone.defaultProps = {
  className: undefined,
  defaultHeight: 25,
  defaultWidth: 15,
  fill: "#000000"
};

export default Phone;
